/* IT HIPPIE — verrouillage du fond quand le panier est ouvert sur mobile.
   1) On fige le <body> (position:fixed) : marche bien sur Safari iOS.
   2) On bloque aussi les gestes tactiles (touchmove) partout SAUF dans la liste
      d'articles (.cart-drawer__main) : indispensable pour Chrome iOS, où figer le
      body ne suffit pas toujours.
   La liste d'articles reste scrollable ; les taps (fermer, champs, boutons) ne sont
   pas bloqués (touchmove != tap). Limité au mobile (<=749px). */
(function () {
  var cd = document.querySelector('cart-drawer');
  if (!cd) return;

  var scrollY = 0;
  var locked = false;

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  // Laisse scroller uniquement la liste d'articles ; bloque le scroll partout ailleurs.
  function onTouchMove(e) {
    var main = cd.querySelector('.cart-drawer__main');
    if (main && e.target && main.contains(e.target)) return;
    e.preventDefault();
  }

  function lock() {
    if (locked || !isMobile()) return;
    locked = true;
    scrollY = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = '-' + scrollY + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    document.addEventListener('touchmove', onTouchMove, { passive: false });
  }

  function unlock() {
    if (!locked) return;
    locked = false;
    document.removeEventListener('touchmove', onTouchMove, { passive: false });
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    window.scrollTo(0, scrollY);
  }

  new MutationObserver(function () {
    if (cd.classList.contains('is-visible')) lock();
    else unlock();
  }).observe(cd, { attributes: true, attributeFilter: ['class'] });
})();
